export default __webpack_public_path__ + "static/media/instagramWhite.8d8a5e7a.svg";